import { connect } from "react-redux";
import NativeAppBanner from "./NativeAppBanner";
import {
  getStoreCode,
  getDefaultStoreUrl
} from "../../state/modules/regionalStore";

function mapStateToProps(state) {
  return {
    welcomeMessage: state.welcomeMessage,
    storeCode: getStoreCode(state),
    defaultStoreUrl: getDefaultStoreUrl(state)
  };
}

export default connect(mapStateToProps)(NativeAppBanner);
